module.exports = __webpack_public_path__ + "img/registre.e915b8de.jpg";